import { uuidv4, waiter } from './utils.js';
import { ViewController } from '../libs/view-controller.js';


var dialogCSSLoaded = false;
/**
 * load the Datatables CSS
 * 
 * This CSS make the table take the whole height on container
 */
export function initDialogs(){
    if(dialogCSSLoaded){ return ;}

    var css = "";
    //.modal-body { max-height: calc(100vh - 60px); overflow: auto; }";
    css += ".modal-above-all { z-index: 9999; } \n";
    css += ".modal-lg.modal-fullscreen { max-width: 98%; } \n";
    css += ".modal-lg .modal-body { height: calc(100vh - 60px);  overflow: auto;} \n";
    css += "@media (min-width: 992px) {"+
        ".modal-md { "+
        "    max-width:50% "+
        "}"+
        ".modal-lg .modal-body { height: calc(100vh - 121px); }"+
        "}" ;
        css += "@media (max-width: 992px) {"+
        ".modal-lg.modal-fullscreen .modal-content {"+
            "height: 100%;"+
        "}"+
        ".modal-lg.modal-fullscreen {"+
            "max-width: 102%;"+
            "margin: 0;"+
            "position: absolute;"+
            "left: -1px;"+
            "top: 0;"+
            "bottom: 0;"+
            "right: -1px;"+
            "overflow: auto;"+
            "padding: 0;"+
            "border: 0;"+
            "border-radius: 0;"+
            "box-shadow: none;"+
        "}"+
    "}" ;

    var head = document.getElementsByTagName('head')[0];
    var s = document.createElement('style');
    s.setAttribute('type', 'text/css');
    if (s.styleSheet) {   // IE
        s.styleSheet.cssText = css;
    } else {                // the world
        s.appendChild(document.createTextNode(css));
    }
    head.appendChild(s);
    dialogCSSLoaded = true ;
}

function makeDraggable($elModal){
    var $elHeader = $elModal.find(".modal-header") ;
    var draggableData = {};
    $elHeader.on('mousedown', function (event) {
        draggableData.isMouseDown = true;
        var dialogOffset = $elModal.offset();
        draggableData.mouseOffset = {
            top: event.clientY - dialogOffset.top,
            left: event.clientX - dialogOffset.left
        };
    });
    $elModal.on('mouseup mouseleave', function () {
        draggableData.isMouseDown = false;
    });
    window.jQuery('body').on('mousemove', function (event) {
        if (!draggableData.isMouseDown) {
            return;
        }
        $elModal.offset({
            top: event.clientY - draggableData.mouseOffset.top,
            left: event.clientX - draggableData.mouseOffset.left
        });
    });
}

export function info(message, callback) {
    initDialogs();
    let msgOk = window.tr("global.ok") ;
    if(msgOk === "global.ok"){
        msgOk = "OK" ;
    }
    const modalHtml = '<div class="modal fade modal-above-all" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">'+
    '  <div class="modal-dialog modal-dialog-centered" role="document">'+
    '    <div class="modal-content shadow">'+
    '      <div class="modal-header bg-info">'+
    '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
    '          <span aria-hidden="true">&times;</span>'+
    '        </button>'+
    '      </div>'+
    '      <div class="modal-body p-2">'+
    (""+message).replace(/\n/g, "<br />")+
    '      </div>'+
    '      <div class="modal-footer">'+
    '        <button type="button" class="btn btn-primary" data-dismiss="modal">'+msgOk+'</button>'+
    '      </div>'+
    '    </div>'+
    '  </div>'+
    '</div>' ;
    const $modal = window.jQuery(modalHtml);
    $modal.modal() ;
    makeDraggable($modal) ;
    const promiseClose = new Promise((resolve)=>{
        $modal.on('hidden.bs.modal', function () {
            if(callback) {callback() ;}
            resolve() ;
        });
    }) ;
    return promiseClose ;
    
} 


export function error(message, callback) {
    initDialogs();
    if(message && message.message === "Failed to fetch"){
        message = window.tr("global.cantConnect") ;
    }
    if(typeof(message) === "object"){
        console.error("unexpected error", message) ;
        if(message && message instanceof Error){
            message = window.tr("global.unexpectedError", {err : message.message+"\n"+message.stack}) ;
        }else{
            message = window.tr("global.unexpectedError", {err : JSON.stringify(message)}) ;
        }
    }

    let msgOk = window.tr("global.ok") ;
    if(msgOk === "global.ok"){
        msgOk = "OK" ;
    }
    
    var modalHtml = '<div class="modal fade modal-above-all" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">'+
    '  <div class="modal-dialog modal-dialog-centered" role="document">'+
    '    <div class="modal-content shadow">'+
    '      <div class="modal-header bg-danger">'+
    '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
    '          <span aria-hidden="true">&times;</span>'+
    '        </button>'+
    '      </div>'+
    '      <div class="modal-body p-3">'+
    (""+message).replace(/\n/g, "<br />")+
    '      </div>'+
    '      <div class="modal-footer">'+
    '        <button type="button" class="btn btn-primary" data-dismiss="modal">'+msgOk+'</button>'+
    '      </div>'+
    '    </div>'+
    '  </div>'+
    '</div>' ;
    var $modal = window.jQuery(modalHtml);
    $modal.modal() ;
    makeDraggable($modal) ;
    const promiseClose = new Promise((resolve)=>{
        $modal.on('hidden.bs.modal', function () {
            if(callback) {callback() ;}
            resolve() ;
        });
    }) ;
    return promiseClose ;
} 

export function confirm(message, options={}) {
    if(options.aboveAll === undefined){
        options.aboveAll = true ;
    }
    return question(message, options, [
        {label : window.tr("global.no"), code: false, className: "btn-secondary", focus: options.focusToNoButton, isDefault: true},
        {label : window.tr("global.yes"), code: true, className: "btn-primary", focus: !options.focusToNoButton}
    ]) ;
} 
    
export function question(message, options={}, buttons=[]) {
    initDialogs();
    if(Array.isArray(options)){
        buttons = options ;
        options = null;
    }

    if(!options){
        options = {} ;
    }

    options.keyboard = options.closeWithEsc ;
    if(options.keyboard === undefined){
        options.keyboard = true ;
    }
    if(options.closeWithEsc === false && options.closeByClickOutside === undefined){
        options.closeByClickOutside = false ;
    }
    if(options.closeByClickOutside === false){
        options.backdrop = "static" ;
    }
    
    var modalSize = "";
    if(options.size==="small"){
        modalSize = "modal-sm";
    }else if(options.size==="medium"){
        modalSize = "modal-md";
    }else if(options.size==="large"){
        modalSize = "modal-lg";
    }else if(options.size==="fullscreen"){
        modalSize = "modal-lg modal-fullscreen";
    }


    var modalHeaderClass = "bg-light" ;
    if(options.headerClass){
        modalHeaderClass = options.headerClass ;
    }

    var modalHtml = '<div class="modal fade '+(options.aboveAll?"modal-above-all":"")+'" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">'+
    '  <div class="modal-dialog modal-dialog-centered '+modalSize+' " role="document">'+
    '    <div class="modal-content shadow">'+
    '      <div class="modal-header '+modalHeaderClass+'">'+
    '        <h5 class="modal-title">'+(options.title||'&nbsp;')+'</h5>';
    if(options.closeable === true || options.closeable === undefined){
        modalHtml += '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
        '          <span aria-hidden="true">&times;</span>'+
        '        </button>' ;
    } 
    modalHtml += '      </div>'+
    '      <div class="modal-body p-2">'+
    (""+message).replace(/\n/g, "<br />")+
    '      </div>'+
    '      <div class="modal-footer">'+
    buttons.map(function(button){
        return '<button type="button" class="btn '+button.className+' btn-'+button.code+'">'+button.label+'</button>' ;  
    }).join("")+
    '      </div>'+
    '    </div>'+
    '  </div>'+
    '</div>' ;

    var $modal = window.jQuery(modalHtml);
    if(options.zIndex){
        $modal[0].style.zIndex = options.zIndex ; 
    }
    $modal.modal(options) ;
    var callbackCalled = false;
    return new Promise((resolve)=>{
        buttons.forEach(function(button){
            var $button = $modal.find(".btn-"+button.code);
            if(button.focus){
                $modal.on('shown.bs.modal', function () {
                    $button.focus() ;
                });
            }
            $button.on("click", function(){
                callbackCalled = true;
                $modal.modal("hide");
                resolve(button.code) ;
            });
            if(button.isDefault){
                $modal.on('hide.bs.modal', function () {
                    if(!callbackCalled){
                        //closed by ESC
                        resolve(button.code) ;
                    }
                });
            }
        }) ;
        makeDraggable($modal) ;
    }) ;
}

export function viewDialog(viewHtml, dialogOptions, callback, callbackClose) {
    if(typeof(dialogOptions) === "function"){
        callbackClose = callback;
        callback = dialogOptions;
        dialogOptions = null;
    }

    if(!callback){ callback = function(){} ; }

    let routeToRender = null;
    if(viewHtml.route){
        routeToRender = viewHtml.route ;
        viewHtml = `<z-view class="h-100"></z-view>` ;
    }

    return waiter(openDialog((el, $modal)=>{
        const options = {id : dialogOptions?dialogOptions.id:""} ;
        if(viewHtml.indexOf("<") === -1){
            options.page = viewHtml ;
        }
        const viewController = new ViewController(options) ;
        viewController.embedded = true;
        viewController.actions.closePopup = (result)=>{
            $modal.modal('hide') ;
            callback(result) ;
        } ;
        $modal.on('hidden.bs.modal', function () {
            const zView = viewController.body.querySelector("z-view") ;
            if(zView && zView.firstElementChild && zView.firstElementChild.shadowRoot){
                zView.firstElementChild.shadowRoot.dispatchEvent(new CustomEvent("popupClose"));
            }
            if(callbackClose){
                callbackClose() ;
            }
        });
        let promisePrepare = Promise.resolve() ;
        if(!options.page){
            viewController.createTemplate(viewHtml) ;
        }else{
            promisePrepare = viewController.prepareView() ;
        }
        return promisePrepare.then(()=>{
            return viewController.renderView(el, {params : { callback: callback }}).then(()=>{
                if(routeToRender){
                    const zView = viewController.body.querySelector("z-view") ;
                    zView.prepareController(routeToRender) ;
                    if(!zView.viewController){ throw "Missing controller for "+routeToRender ; }
                    zView.viewController.embedded = true ;
                    zView.viewController.data = {} ;
                    zView.viewController.actions.closePopup = viewController.actions.closePopup ;
                    return zView.viewController.prepareView().then(()=>{
                        return zView.viewController.renderView(zView, {params: zView.params}).then(()=>{
                            return zView.viewController ;
                        }) ;
                    });
                }else{
                    return viewController ;
                }
            });
        }) ;
    }, dialogOptions)) ;
}

export function openDialog(viewRender, options) {
    initDialogs();
    if(!options){
        options = {} ;
    }

    options.keyboard = options.closeWithEsc ;
    if(options.keyboard === undefined){
        options.keyboard = true ;
    }
    if(options.closeWithEsc === false && options.closeByClickOutside === undefined){
        options.closeByClickOutside = false ;
    }
    if(options.closeByClickOutside === false){
        options.backdrop = "static" ;
    }
    
    var modalSize = "";
    if(options.size==="small"){
        modalSize = "modal-sm";
    }else if(options.size==="medium"){
        modalSize = "modal-md";
    }else if(options.size==="large"){
        modalSize = "modal-lg";
    }else if(options.size==="fullscreen"){
        modalSize = "modal-lg modal-fullscreen";
    }

    var modalHeaderClass = "bg-light" ;
    if(options.headerClass){
        modalHeaderClass = options.headerClass ;
    }

    var id = uuidv4() ;

    var modalHtml = '<div class="modal fade '+(options.aboveAll?"modal-above-all":"")+'" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">'+
    '  <div class="modal-dialog modal-dialog-centered '+modalSize+' " role="document">'+
    '    <div class="modal-content shadow">'+
    '      <div class="modal-header '+modalHeaderClass+'">'+
    '        <h5 class="modal-title">'+(options.title||'&nbsp;')+'</h5>';
    if(options.closeable === true || options.closeable === undefined){
        modalHtml += '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
        '          <span aria-hidden="true">&times;</span>'+
        '        </button>' ;
    } 
    modalHtml += '      </div>'+
    '      <div class="modal-body p-2" id="'+id+'">'+
    '      </div>'+
    '    </div>'+
    '  </div>'+
    '</div>' ;

    return new Promise((resolve, reject)=>{
        var $modal = window.jQuery(modalHtml);
        if(options.zIndex){
            $modal[0].style.zIndex = options.zIndex ; 
        }
        $modal.modal(options) ;
        $modal.on('shown.bs.modal', function () {
            const renderPromise = viewRender(document.getElementById(id), $modal) ;
            if(renderPromise){
                renderPromise.then((res)=>{
                    resolve(res) ;
                }).catch((err)=>{ reject(err) ; }) ;
            }else{
                resolve() ;
            }
        });
        $modal.on('hidden.bs.modal', function () {
            $modal.modal("dispose") ;
        });
        makeDraggable($modal) ;
    }) ;

}